import React from 'react';

function ReturnReceiptModal({ isOpen, onClose, modalData }) {
  if (!isOpen) return null;

  // Function to get session name by ID
  const getSessionName = (sessionId) => {
    const sessionObj = modalData?.session?.find((s) => s.id === sessionId);
    return sessionObj ? sessionObj.name : sessionId;
  };

  const getMenuItemName = (menuItemId) => {
    const menuItemObj = modalData?.menu_item?.find((m) => m.id === menuItemId);
    return menuItemObj ? menuItemObj.item_name : menuItemId;
  };


  // Function to extract menu item name from kit_no
  const getMenuItemFromKitNo = (kitNo) => {
    if (!kitNo) return '';
    const parts = kitNo.split('/');
    if (parts.length >= 3) {
      return parts[2]; // third part is the menu item
    }
    return '';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">
            Date: {modalData?.date} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ingredient: {modalData?.ingredient}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Returned QTY</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Session</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Menu Item</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Kit No</th>
              </tr>
            </thead>
            <tbody>
              {modalData?.details?.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">{item.return_qty}</td>
                  <td className="border border-gray-300 px-4 py-2">{getSessionName(item.session)}</td>
                  <td className="border border-gray-300 px-4 py-2">{getMenuItemName(item.menu_item)}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.kit_no}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-red-400 text-white px-4 py-2 rounded hover:bg-red-300"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReturnReceiptModal;
